"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cupello": {
    "9c0a90a5": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "bufalara": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99d70404": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "cena": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6c2d8cf6": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "colle-mincuccio": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f9b81b3": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "fucile": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3987d5c8": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "reale": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f99adea2": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "scosse": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a910f545": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "strampalato": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0db02f1": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "strane": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5236ea97": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "skipSearch": false
    }],
    "treste": [{
      "hkey": "faba111d",
      "slug": "cupello",
      "name": "Cupello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;